module.exports = __webpack_public_path__ + "img/beachUmbrella.b2298c5d.svg";